import { OrderRequestType } from '..';

export class OrderRequestModel {
    constructor(
        public type?: OrderRequestType,
        public executionOrder: number = 0) {
    }
}
